import "./Team.css"
import alimalekshaian from "../../assets/team_pictures/ali malekshahian.jpg";
import omidabdolvand from "../../assets/team_pictures/omid abdolvand.jpg";
import hassanalawi from "../../assets/team_pictures/hassan-alawi.png";
import mehdinasiri from "../../assets/team_pictures/mehdi nasiri.jpg";
import amirhosseinfallah from "../../assets/team_pictures/amirhossein fallah.jpg";
import mortezaomidi from "../../assets/team_pictures/morteza omidi.png";
import keyvanmoradkhani from "../../assets/team_pictures/keyvan moradkhani.png";
import royapeyro from "../../assets/team_pictures/roya peyro.jpg";
import mobinahejabi from "../../assets/team_pictures/mobina hejabi.jpg";
import masoumebeigi from "../../assets/team_pictures/masoume beigi.jpg";
import zeynabnajafi from "../../assets/team_pictures/zeynab najafi.jpg";
import mandanadashti from "../../assets/team_pictures/mandana dashti.jpg";
import icon from "../../assets/icon.png"
import Loading from "../UI/Loading/Loading";
import {useState, useEffect} from "react";

const Team = () => {
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        window.scrollTo(0, 0);
        const loadingTimeout = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => {
            clearTimeout(loadingTimeout);
        };
    }, [])
    return (
        <>
            {loading && <Loading/>}
            <di className="team-container">
                <div className="team-first">
                    <h1 className={"upToBottomAnimation"}>
                        A team of dedicated professionals committed to exceeding your expectations
                    </h1>
                </div>
                <div className="team-members">
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={alimalekshaian} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3> Ali malekshahian</h3>
                                <p>CEO & CTO</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={omidabdolvand} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Omid Abdolvand</h3>
                                <p>Back-End Developer</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={mandanadashti} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Mandana Dashti</h3>
                                <p>Front-End Developer</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={masoumebeigi} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Masoume Beigi </h3>
                                <p>Front-End Developer</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={zeynabnajafi} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Zeynab Najafi</h3>
                                <p>Back-End Developer</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={mobinahejabi} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Mobina Hejabi</h3>
                                <p>Data Engineer</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <div className="team-image-icon">
                                <img
                                    src={icon}
                                    alt="Team member 1"
                                />
                            </div>
                            <div className="team-info">
                                <h3>Zahra Salavati</h3>
                                <p>Accountant</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <div className="team-image-icon">
                                <img
                                    alt="Team member 1"
                                    src={icon}
                                />
                            </div>
                            <div className="team-info">
                                <h3>Rezvan Vahabi</h3>
                                <p>Accountant</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={royapeyro} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Roya peyro</h3>
                                <p>Graphic Designers</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img
                                src={keyvanmoradkhani}
                                alt="Team member 1"
                                className="team-image"
                            />
                            <div className="team-info">
                                <h3>Keyvan moradkhani</h3>
                                <p>Front-End Developer</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={mortezaomidi} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Morteza omidi</h3>
                                <p>Back-End Developer</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img
                                src={amirhosseinfallah}
                                alt="Team member 1"
                                className="team-image"
                            />
                            <div className="team-info">
                                <h3>Amirhossein fallah</h3>
                                <p>Product Manager</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={mehdinasiri} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Mehdi nasiri</h3>
                                <p>Mobile Developer</p>
                            </div>
                        </div>
                    </div>
                    <div className="team-card-container">
                        <div className="team-card">
                            <img src={hassanalawi} alt="Team member 1" className="team-image"/>
                            <div className="team-info">
                                <h3>Hasan alawi</h3>
                                <p>Front-End Developer</p>
                            </div>
                        </div>
                    </div>
                </div>
            </di>
        </>
    )
}
export default Team;